<template>
    <span class="projectContent">
        <h1 class="projectTitle">
            Web AR for PurpleVerse in NFT.NYC
        </h1>
        <h2 class="projectSubTitle">
            A web AR application for advanced virtual exhibition experience
        </h2>
        <p>
            In collaboration with Mason Webb (Visual)
        </p>
        <h3>
        Mainview: 
        </h3>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/EweZTT1ZY74" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <h3>
        Backview: 
        </h3>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/tecee8YqSo8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <h3>
        User Interaction: 
        </h3>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/qqsmLcJe7Fg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <h3>
        Object Enhancement: 
        </h3>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/3_9cM_HKwcw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <h3>
        Drawing and Commenting function: 
        </h3>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/IbTOC4OwvZE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </span>
  
</template>

<script>
export default {
    name:"purpleVerse"

}
</script>

<style>


</style>